<template>
  <div class="task-card" @click.stop="showInfo(task.id)">
    <div class="task-card__title" :title="task.name">{{ task.name.length > 50 ? `${task.name.slice(0, 50)}...` : task.name }}</div>
    <!--<div class="task-card__status">
      <span class="data">Статус:</span>
      <div class="value">{{ task.status }}</div>
    </div>-->
    <div class="task-card__members">
      <div class="user-avatar task-creator">
        <img v-if="task.owner.avatar !== null && task.owner.avatar.file_size"
             :src="task.owner.avatar.url" :alt="task.owner.name" :title="task.owner.name">
        <img v-else src="/img/avatar-thumb.png" :alt="task.owner.name" :title="task.owner.name">
      </div>
      <span class="task-card__members-icon">
        <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 5.64516L1 10" stroke="currentColor"/>
        </svg>
      </span>
      <div class="user-avatar task-assignee" v-for="user in task.assignees" :key="user.id">
        <img v-if="user.avatar !== null && user.avatar.file_size"
             :src="user.avatar.url" :alt="user.profile.name" :title="user.profile.name">
        <img v-else src="/img/avatar-thumb.png" :alt="user.profile.name" :title="user.profile.name">
      </div>
    </div>
    <div class="task-card__tags">
      <div class="attachment" v-for="(tag, i) in task.tags" :key="i">
        <span class="attachment__tag-icon">#</span>
        <span class="attachment__tag">{{ tag }}</span>
      </div>
    </div>
<!--    крайний срок: {{task.before_at}} {{ task.created_at ? `${formatDate(task.created_at.split(' ').shift())} ${task.before_at.split(' ').pop().slice(0, 5)}` : 'Не установлен'  }}-->
    <div class="task-card__date">крайний срок: {{ task.before_at ? `${formatDate(task.before_at.split(' ').shift())} ${task.before_at.split(' ').pop().slice(0, 5)}` : 'Не установлен'  }}</div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/utils'

export default {
  name: 'task-board-card',
  props: {
    task: Object
  },
  computed: {},
  data () {
    return {}
  },
  methods: {
    showInfo (taskId) {
      this.$emit('show-info', taskId)
    },
    formatDate (date) {
      return formatDate(date)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.task-card {
  background: $color_main;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  padding: 18px 18px 18px 20px;

  &__title {
    font-size: 18px;
    font-weight: bold;
    color: $color_second;
    margin-bottom: 16px;
  }

  &__status {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 16px;
  }

  &__members {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 16px;
  }

  &__members-icon {
    color: $color-second-light;
    margin: 0 6px 8px;
  }

  &__tags {
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 16px;
  }

  &__date {
    color: $font_color_second;
  }
}

.task-creator {
  margin-bottom: 8px;
}

.task-assignee {
  margin-right: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-right: 0;
  }
}

.data {
  color: $font_color_second;
  margin-right: 6px;
}

.attachment {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;

  &__icon {
    color: #D0E7F7;
    margin-right: 10px;
    transform: translateY(-2px);
  }

  &__size {
    margin-left: 6px;
    color: $border_color;
  }

  &__link {
    color: $color_second-light;
    text-decoration: underline;
  }

  &__tag {
    color: $font_color_third;
  }
}
</style>
